var _path, _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.604 9.0489L17.3948 8.1489C17.6144 7.9005 17.5892 7.5201 17.3396 7.3017L12.596 3.1485C12.3692 2.9505 12.032 2.9505 11.8052 3.1485L7.0604 7.3017C6.8108 7.5201 6.7856 7.9005 7.0052 8.1501L7.796 9.0489C8.0156 9.2973 8.3936 9.3213 8.642 9.1041L11 7.0377V15.5997C11 15.9309 11.2688 16.1997 11.6 16.1997H12.8C13.1312 16.1997 13.4 15.9309 13.4 15.5997V7.0377L15.758 9.1041C16.0076 9.3213 16.3856 9.2973 16.604 9.0489ZM5.6 18.6H18.8C19.1312 18.6 19.4 18.8688 19.4 19.2V20.4C19.4 20.7312 19.1312 21 18.8 21H5.6C5.2688 21 5 20.7312 5 20.4V19.2C5 18.8688 5.2688 18.6 5.6 18.6Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 15,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.604 9.0489L17.3948 8.1489C17.6144 7.9005 17.5892 7.5201 17.3396 7.3017L12.596 3.1485C12.3692 2.9505 12.032 2.9505 11.8052 3.1485L7.0604 7.3017C6.8108 7.5201 6.7856 7.9005 7.0052 8.1501L7.796 9.0489C8.0156 9.2973 8.3936 9.3213 8.642 9.1041L11 7.0377V15.5997C11 15.9309 11.2688 16.1997 11.6 16.1997H12.8C13.1312 16.1997 13.4 15.9309 13.4 15.5997V7.0377L15.758 9.1041C16.0076 9.3213 16.3856 9.2973 16.604 9.0489ZM5.6 18.6H18.8C19.1312 18.6 19.4 18.8688 19.4 19.2V20.4C19.4 20.7312 19.1312 21 18.8 21H5.6C5.2688 21 5 20.7312 5 20.4V19.2C5 18.8688 5.2688 18.6 5.6 18.6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#9CA4B5"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.66484d0f.svg";
export { ForwardRef as ReactComponent };